var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 158,
    viewBox: "0 0 87 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4995 0.5C41.8295 0.5 64.1695 0.5 86.4995 0.5C86.4995 3.17 86.4995 5.83 86.4995 8.5C86.4995 58.17 86.4995 107.83 86.4995 157.5C64.1695 157.5 41.8295 157.5 19.4995 157.5C9.03945 154.87 2.87945 148.21 0.999454 137.5C0.499454 97.83 0.329454 58.17 0.499454 18.5C3.62945 9.04 9.95945 3.04 19.4995 0.5Z",
    fill: "#FDFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5 44.5C60.81 44.64 62.98 47.31 62 52.5C53.17 61.33 44.33 70.17 35.5 79C44.33 87.83 53.17 96.67 62 105.5C63.67 111.49 61.5 113.99 55.5 113C44.26 102.26 33.59 91.09 23.5 79.5C24.09 77.73 24.92 76.07 26 74.5C36.08 64.58 45.92 54.58 55.5 44.5Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrow);
export default __webpack_public_path__ + "static/media/navArrow.5177c4e0dd8dcdb96ed92ef25b8cddf0.svg";
export { ForwardRef as ReactComponent };